var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlexBox, IconButton, Modal, ModalBody, ModalFoot, ModalHead, Text, } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { useCallback, useMemo, useState } from 'react';
import { analytics } from 'app/utils/segment';
import { DateCard } from '../dateCard/dateCard';
import styles from './reviewConflictsModal.module.scss';
function getConflictingExceptions(conflicts, conflictedDate) {
    return Object.values(conflicts).filter(({ next_date }) => next_date === conflictedDate);
}
export const ReviewConflictsModal = ({ conflicts, resolvedDates: propResolvedDates = [], onClose, onResolve, }) => {
    const [activeConflictGroup, setActiveConflictGroup] = useState(1);
    const [resolvedDates, setResolvedDates] = useState(propResolvedDates);
    const [resolvedConflicts, setResolvedConflicts] = useState(conflicts);
    const conflictedDates = useMemo(() => [
        ...new Set(Object.values(conflicts).map(({ next_date }) => next_date)),
    ], [conflicts]);
    const { length: conflictsLength } = conflictedDates;
    const handleSelect = useCallback((exception, conflictedDate) => () => {
        setResolvedDates((prevResolvedDates) => [
            ...new Set([...prevResolvedDates, conflictedDate]),
        ]);
        const currentConflicts = getConflictingExceptions(resolvedConflicts, conflictedDate).reduce((acc, curr) => {
            const { overridden_by } = curr, rest = __rest(curr, ["overridden_by"]);
            return Object.assign(Object.assign({}, acc), { [curr.id]: Object.assign(Object.assign({}, rest), (curr.id !== exception.id && {
                    overridden_by: {
                        id: exception.id,
                        date: exception.next_date,
                    },
                })) });
        }, {});
        setResolvedConflicts((prevResolvedDates) => (Object.assign(Object.assign({}, prevResolvedDates), currentConflicts)));
        if (activeConflictGroup < conflictsLength) {
            setTimeout(() => {
                setActiveConflictGroup((prevActiveConflictGroup) => prevActiveConflictGroup + 1);
            }, 500);
        }
    }, [activeConflictGroup, conflictsLength, resolvedConflicts]);
    const handleSubmit = useCallback(() => {
        analytics.businessHoursScheduleReviewFormSubmitted();
        onResolve(resolvedConflicts);
        onClose();
    }, [resolvedConflicts, onClose, onResolve]);
    const handleClose = useCallback(() => {
        analytics.businessHoursScheduleReviewFormCancelled();
        onClose();
    }, [onClose]);
    return (_jsx(Modal, Object.assign({ isOpen: true, onClose: handleClose }, { children: _jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx("form", { onSubmit: handleSubmit }), _jsx(ModalHead, Object.assign({ title: "Review conflicts", onClose: handleClose }, { children: _jsx(Text.Paragraph, Object.assign({ className: styles.description }, { children: "Please choose the business hours that apply for the below dates:" })) })), _jsxs(ModalBody, { children: [conflictsLength > 1 && (_jsxs(FlexBox, Object.assign({ alignItems: "center", justifyContent: "space-between" }, { children: [_jsx(IconButton, { disabled: activeConflictGroup === 1, icon: "angle-left", iconSize: 24, onClick: () => setActiveConflictGroup((prevActiveConflictGroup) => prevActiveConflictGroup - 1), variant: "tertiary" }), _jsxs(Text.Paragraph, Object.assign({ className: styles.conflictControlText }, { children: ["Conflict ", activeConflictGroup, " of ", conflictsLength] })), _jsx(IconButton, { disabled: activeConflictGroup === conflictsLength, icon: "angle-right", onClick: () => setActiveConflictGroup((prevActiveConflictGroup) => prevActiveConflictGroup + 1), variant: "tertiary" })] }))), conflictedDates.map((conflictedDate, index) => {
                            const isResolved = resolvedDates.indexOf(conflictedDate) > -1;
                            return (_jsx("div", Object.assign({ className: classNames(styles.conflictList, {
                                    [styles.conflictListHidden]: activeConflictGroup !== index + 1,
                                }) }, { children: getConflictingExceptions(resolvedConflicts, conflictedDate).map((exception) => {
                                    return (_jsx(DateCard, { exception: exception, isSelected: isResolved && !exception.overridden_by, onClick: handleSelect(exception, conflictedDate) }, exception.id));
                                }) }), conflictedDate));
                        })] }), _jsx(ModalFoot, { cancelOnClick: handleClose, confirmProps: {
                        disabled: resolvedDates.length !== conflictsLength,
                    }, confirmName: "Resolve", confirmOnClick: handleSubmit })] })) })));
};
